var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.875C10.0355 15.875 10.875 15.0355 10.875 14C10.875 12.9645 10.0355 12.125 9 12.125C7.96447 12.125 7.125 12.9645 7.125 14C7.125 15.0355 7.96447 15.875 9 15.875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.25C20.0355 10.25 20.875 9.41053 20.875 8.375C20.875 7.33947 20.0355 6.5 19 6.5C17.9645 6.5 17.125 7.33947 17.125 8.375C17.125 9.41053 17.9645 10.25 19 10.25Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.5C20.0355 21.5 20.875 20.6605 20.875 19.625C20.875 18.5895 20.0355 17.75 19 17.75C17.9645 17.75 17.125 18.5895 17.125 19.625C17.125 20.6605 17.9645 21.5 19 21.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.634 14.9192L17.366 18.7059M17.366 9.29419L10.634 13.0809",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share-2.410cd676ad5d2ae933c28c9b3af3dbf7.svg";
export { ForwardRef as ReactComponent };